<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <section class="bread_crumb">
            <div class="container">
                <ul>
                    <li>
                        <router-link class="nav-link" v-bind:to="'/'">{{ $t("Header.Home") }}</router-link>
                    </li>
                    <li>Cart</li>
                </ul>
            </div>
        </section>
        <section class="inner_wrap">
            <div class="container">   
                <h2>Cart</h2>
                <div v-if="cart_error!=''" class="alert alert-danger alert-dismissible fade show" role="alert">
                    <ul>
                        <li>{{cart_error}}</li>
                    </ul>
                </div>
                <div class="cart_page"  v-if="cart_listing != null && cart_listing.length">   
                    <table class="cart-table">
                        <tbody>
                            <tr>
                                <th></th>
                                <th>Image</th>
                                <th>Course</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Total</th>
                            </tr>
                            <tr  v-for="item in cart_listing" :key="item.id" :class="['item--' + item.id]">
                                <td>
                                    <a href="javascript:;" class="delete" v-on:click="remove_from_cart1(item.id)">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </a>
                                </td>
                                <td>
                                    <div class="item-pic">
                                        <img :src="hostname+'/admin/images/course_images/'+item.details.image" :alt="item.details.name_eng">
                                    </div>
                                </td>
                                <td>
                                    <router-link class="nav-link"   v-bind:to="'/courses/'+item.details.slug">
                                        {{item.details.name_eng}}
                                    </router-link>
                                </td>
                                <td>
                                    <input type="number" name="qty" :value="item.qty" @keypress="validateNumber" @change="updateQty($event,item.id)">
                                </td>
                                <td>
                                    <h6>${{item.details.amount}}</h6>
                                </td>
                                <td>
                                    <h6>${{item.details.amount * item.qty}}</h6>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="cart-total">
                        <ul>
                            <li>
                                <span>Sub Total:</span>
                                <b>${{ get_cart_total }}</b>
                            </li>
                            <li>
                                <span>Tax:</span>
                                <b>${{ total_tax }}</b>
                            </li>
                            <li>
                                <span>Total:</span>
                                <b>${{ total_amount }}</b>
                            </li>
                        </ul>
                        <div class="common_btn">
                            <a href="javascript:;" class="btn primary-btn" @click="checkout()">Checkout</a>
                            <router-link class="nav-link btn primary-btn continue-shopping" v-bind:to="'/'">
                                Continue Shoping
                            </router-link>
                        </div>
                    </div>
                </div>
                <p v-else-if="cart_listing == null">Getting information</p>
                <p v-else>No items in Cart</p>
            </div>
        </section>
    </div>
</template>


<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import router from '../../router'
export default{
    data() {
        this.get_cart_items();
        this.get_tax_percentage();
        return {
            hostname:this.$hostname,
            cart_listing:null,
            cart_total:0,
            tax:15,
            tax_amount:0,
            cart_subtotal:0,
            total_amount:0,
            cart_error:''
        }
    },
    components:{
        HeaderMenu:HeaderMenu
    },
    methods: {
        validateNumber: event => {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
                event.preventDefault();
            }
        },
        remove_from_cart1(course_id){
            this.$store.commit('remove_form_cart',course_id);
            $('.item--'+course_id).remove();
            this.get_cart_items();
        },
        updateQty(event,id){
            var _self = this;
            var course = this.$store.state.Cart.cart_items.find(row => row.id === id);
            
            this.get_course_qty(id).then(function(response){
                var original_qty = response.data.qty;
                if(parseInt(event.target.value) > original_qty){
                    _self.show_cart_error("You cannot add value more than "+original_qty);
                    $(event.target).val(event.target.value);
                    return false;
                }
                else{
                    _self.$store.commit('update_qty',{course:course,old_qty:course.qty,qty:parseInt(event.target.value)});
                    _self.get_cart_items();
                }
            });
        },
        show_cart_error(msg){
            var _self = this;
            _self.cart_error = msg;
            setTimeout(function(){
                _self.cart_error = "";
            },2000);
        },
        async get_course_qty(course_id) {
            var _self = this;
            return await this.$axios_global.post(_self.$hostname+'/api/get-course-qty',{
                course_id:course_id    
            })
            .then((res) => {
                return res;        
            })        
            .catch((error) => {
                return false;  
            }) 
        },
        async get_cart_items() {
            var _self = this; 
            await this.$axios_global.post(_self.$hostname+'/api/cart-items',{
                items:this.$store.state.Cart.cart_items
            })
            .then((res) => {
                var response = res.data.data.items;
                for(var i=0;i<response.length;i++){
                    if(!response[i].details){
                        this.$store.commit('remove_form_cart',response[i].id);
                        response.splice(i, 1);

                    }
                }
                this.cart_listing = response;
            })
            .catch((error) => {
                return false;  
            }) 
            return false; 
        },
        async get_tax_percentage() {
            var _self = this; 
            await this.$axios_global.post(_self.$hostname+'/api/get-tax-percentage')
            .then((res) => {
                var response = res.data.tax;
                this.tax = parseFloat(response);
            })
            .catch((error) => {
                return false;  
            }) 
            return false; 
        },
        checkout(){
            this.$store.commit('update_sub_total',this.cart_subtotal);
            this.$store.commit('update_tax',this.tax_amount);
            this.$store.commit('update_cart_total_amount',this.total_amount);
            if(this.$store.state.auth.isLoggedIn){
                router.push({name: 'Checkout'})
            }
            else{
                router.push({name: 'Login',query: { redirect: "Checkout" }})
            }
        }
    },
    computed: {
        get_cart_total(){
            this.cart_subtotal = this.cart_listing.reduce( (Sum, cart) => cart.details.amount * cart.qty + Sum  ,0)
            return this.cart_subtotal;
        },
        total_tax() {
            var tax = (this.cart_subtotal * (this.tax/100)).toFixed(2);
            this.total_amount = (parseFloat(this.cart_subtotal) + parseFloat(tax)).toFixed(2);

            this.tax_amount = tax;
            return tax;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Checkout/CartPage.vue